(function () {
    'use strict';

    angular
        .module('app')
        .controller('SchoolsController', SchoolsController);

    SchoolsController.$inject = ['$state',];

    function SchoolsController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'schools') {
                $state.go('schools.list');
            }
        }
    }
})();